import { render, staticRenderFns } from "./TestItemMultiple.vue?vue&type=template&id=8828f194&scoped=true&"
import script from "./TestItemMultiple.vue?vue&type=script&lang=js&"
export * from "./TestItemMultiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8828f194",
  null
  
)

export default component.exports